import { useEffect, useState } from "react";
import BackButton from "../utils/backButton";
import { GetGlobalColor } from "../utils/globalColors";
import { Icons } from "../utils/icons";
import Spinner from '../utils/spinner';

const GameInfo = () => {
  const color = GetGlobalColor();
  const [user, setUser] = useState();
  const [startedAt, setStartedAt] = useState();
  const [avatar, setAvatar] = useState();
  const token = localStorage.getItem('userToken');
  const gameId = localStorage.getItem('gameId');
  const [loading, setLoading] = useState(true);

  const getGameInfo = async () => {

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/game/getGameInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: token, gameId: gameId }),
      });

      const result = await response.json();
      console.log("Response from APFSAFDI:", result);

      if (result.game_data) {
        console.log("Response from API:", result.game_data);
        setUser(result.game_data[0]["username"])

        setStartedAt(result.game_data[0]["started_at"])
        setAvatar(result.game_data[0]["avatar_name"])

      }

    } catch (error) {
      console.error("Error calling API:", error);
    }
    finally{
       setLoading(false);
    }
  };

  useEffect(() => {
    getGameInfo();
  }, []);

  const formattedStartedAt = new Date(startedAt).toLocaleString("sl-SI", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <>
      <div className={`box card-bg-${color} `}>
         {loading &&
                <Spinner />
            }
        <p className="text-3xl font-bold ytext mb-4">Hej {user} <Icons avatar={avatar} />!</p>
        <p className="text-xl font-bold wtext mb-4">Igranje od {new Date(startedAt).toLocaleString()}</p>
      </div>
    </>
  )
}

export default GameInfo;

